import React, { Component }  from 'react';
import { SystemsConstants }  from './environment';
import { isInRoleFromToken } from '../../../utils/authService';

class SystemsBreadcrumb extends Component {

  render() {
    if (isInRoleFromToken(SystemsConstants.UserRole)) {
      return (
        <div className="c-breadcrumbs__wrapper" >
          <ul className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={SystemsConstants.UserHashPrefix + '/provision'} className="anchor c-breadcrumbs__anchor" >
                Provision
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else {
      // Not logged in or wrong role
    }
  }
}

export default SystemsBreadcrumb;